import { useState, useEffect } from 'react'
import { selectStyle, Spinner, apiClient } from '../../utils/helpers';
import {
  ChevronRightIcon
} from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';
import { countries_en } from '../../utils/countries';
import ReactSelect from 'react-select';

export default function BookingStep2(props) {

  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);
  const [verify, _setVerify] = useState(false);
  const [customerLoaded, setCustomerLoading] = useState(false);
  const [customer, setCustomer] = useState({    
    first_name: '',
    last_name: '',
    gender: '',
    country_code_id: '',
    phone: '',
    email: '',
    isNew: false
  });

  useEffect(() => {
    // TODO::For refresh, if customer already exists, probably should not fetchCustomer. 
    fetchCustomer()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {
    props.setBkinfo({
      ...props.bkinfo,
      customer_id:customer.id,
      customer:customer,
    })  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[customer.id]);

  async function fetchCustomer() {
    
    if(props.bkinfo.phone || props.bkinfo.email) {
      await apiClient.post(`/api/get_customer`,{      
        country: props.bkinfo.country,
        phone: props.bkinfo.phone,
        email: props.bkinfo.email,
      })
      .catch(function(err){
        setError(err.response.data.errors)
      })
      .then((response) => {      
        if(response.data) {        
          setCustomer({
            ...customer,
            id: response.data.id,
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            gender: response.data.gender,
            country_code_id: response.data.country_code ? response.data.country_code.id : 86,
            phone: response.data.phone,
            email: response.data.email,
            isNew: false
          })
          setCustomerLoading(true);
        } else {
          setCustomer({
            ...customer,
            country_code_id: props.bkinfo.country || countries_en[0].value,
            phone: props.bkinfo.phone,
            email: props.bkinfo.email,
            isNew: true
          })
          setCustomerLoading(true);
        }
      })
    } else {
      setCustomer({
        ...customer,
        country_code_id: props.bkinfo.country || countries_en[0].value,
        phone: props.bkinfo.phone,
        email: props.bkinfo.email,
        isNew: true
      })
      setCustomerLoading(true);
    }
  }

  async function confirmDeets() {

    if(!customer.phone) {
      setError({0: 'please_enter_phone'})
      return
    }

    setLoading(true)

    let endpoint = customer.isNew ? 'add_customer' : 'update_customer/'+customer.id

    await apiClient({
      method: customer.isNew ? 'post' : 'put',
      url: `/api/${endpoint}`,
      data: customer,
    })    
    .then((response) => {
      if(response && response.data && !response.data.error) {

        setCustomer({
          ...customer,
          id: response.data
        })

        props.setBkinfo({
          ...props.bkinfo,
          customer_id: response.data,
          phone: customer.phone || props.bkinfo.phone,
          email: customer.email || props.bkinfo.email,
          country: customer.country_code_id || props.bkinfo.country,
          last_step: 2
        })

      } else {
        setError({0: 'Something went wrong. Please try again.'})
      }
    })
    .catch(function(err){
      if(err.response && err.response.data && err.response.data.errors) {
        setError(err.response.data.errors)
      } else {
        setError({0: 'Network error. Please check your connection and try again.'})
      }
    })
    .finally(() => {      
      setLoading(false)
    })
  }

  return (
      <>

        <h4 className="font-bold text-gold">
          {
            !customer.isNew ?
            <>
              {t('welcome_back',{
                gender: customer.gender === 'M' ? t('mr') : t('ms'),
                fname: customer.first_name,
                lname: customer.last_name
              })}
            </>
            :
            <>{t('welcome')}</>
          }
        </h4>

        {
          !customerLoaded ?
          <div className="flex my-5
          ">
            <Spinner className="!w-8" />
          </div>
          :
          <>
            <div className="flex flex-col gap-5 mt-1 mb-3">

              <div className="flex flex-col gap-1">
              {
                !customer.isNew ?
                <p>{t('please_check')}</p>
                :
                <p>{t('please_fill')}</p>
              }

              {
                !customer.phone &&
                <p>{t('please_enter_phone')}</p>
              }
              </div>
              

              <div className="flex flex-col md:flex-row gap-5">
                <div className="flex gap-3">
                  <div className="w-1/2">
                    <label className="text-xs font-bold mb-1 block">{t('fname')}</label>
                    <input className="w-full" type="text" onChange={(e) => setCustomer({...customer,first_name: e.target.value})} value={customer.first_name}/>
                  </div>
                  <div className="w-1/2">
                    <label className="text-xs font-bold mb-1 block">{t('lname')}</label>
                    <input className="w-full" type="text" onChange={(e) => setCustomer({...customer,last_name: e.target.value})} value={customer.last_name}/>
                  </div>
                </div>
                <div className="">
                  <label className="text-xs font-bold mb-1 block">{t('gender')}</label>
                  <div className="flex gap-3 md:mt-3">
                    <label className="flex items-center gap-1">
                      <input type="radio" name="gender" value="M" onChange={(e) => setCustomer({...customer,gender:'M'})} checked={ customer.gender === 'M' ? true : ''} className="w-5 h-5"/>
                      <span>{t('male')}</span>
                    </label>
                    <label className="flex items-center gap-1">
                      <input type="radio" name="gender" value="F" onChange={(e) => setCustomer({...customer,gender:'F'})} checked={ customer.gender === 'F' ? true : ''} className="w-5 h-5"/>
                      <span>{t('female')}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex flex-col md:flex-row gap-5">
              {
                props.bkinfo.phone ?
                <div className="w-full md:w-1/3">
                  <label className="text-xs font-bold mb-1 block">{t('phone')}</label>
                  <p className="text-green-500 font-bold w-full p-1.5 px-4 border-2 border-[#414F70] bg-green-500/10 rounded">
                    {`+${customer.country_code_id} ${customer.phone}`}
                  </p>
                </div>
                :
                <div className="flex flex-col">
                  <label className="text-xs font-bold mb-1 block">{t('phone')}</label>
                  <div className="flex gap-2">
                    <ReactSelect
                        styles={selectStyle}
                        className="text-left w-full md:w-[150px]"
                        options={countries_en}
                        onChange={(e) => setCustomer({
                                          ...customer,
                                          country_code_id: e.value
                                        })}
                        value={countries_en.find(c => c.value === customer.country_code_id) || countries_en[0]}
                    />
                    <input required type="number" value={customer.phone} onChange={(e) => setCustomer({...customer,phone: e.target.value})} placeholder={t('your_phone')} className="w-full md:w-auto"/>
                  </div>
                </div>
              }            
                <div className="w-full md:flex-1">
                  <label className="text-xs font-bold mb-1 block">{t('email')}</label>
                  <input type="text" onChange={(e) => setCustomer({...customer,email:e.target.value})} value={customer.email} className="w-full"/>
                </div>            
              </div>

              {
                error &&
                <div className="text-center text-red-500">
                  {
                    Object.entries(error).map(([key, value]) => (
                        <div key={key}>{t(value)}</div>
                    ))
                  }
                </div>
              }
              
              <button disabled={loading ? true : ''} onClick={() => confirmDeets() } className="w-full flex justify-center md:w-1/2 mx-auto bg-gold text-sm font-bold opacity-90 hover:opacity-100 p-3 px-4 mt-3 rounded-lg">
                {
                  loading ?
                  <>
                    <Spinner />
                  </>
                  :
                  <>
                    {t('confirm')}
                  </>
                }
              </button>
            </div>

            {
              verify &&
              <div className="w-full flex justify-end">
                  <button className="">
                    {t('next')} <ChevronRightIcon className="inline-block w-4 text-white"/>
                  </button>
              </div>
            } 
          </>
        }

      </>

  );
}